import React, { useState } from 'react'

import RcUpload from 'rc-upload'
import { uploadFile } from '../../service/api/knowledge'
import './index.css'
import Toast from '../Toast'
export type AcceptType = 'file' | 'image' | 'video/mp4'
const acceptImage = 'image/jpeg,image/png'
interface UploadProps {
    // accept?: string
    lt?: number
    acceptType?: AcceptType
    acceptFile?: string
    onExceed?: () => void
    onResolve?: (src: string, name: string, type: string) => void
    onStart?: (file: File) => void // 可以在这里打开 loading 状态
    onfinally?: () => void // 不管成功失败都会调用这个函数,用来关闭 loading 状态
}

const Upload: React.FC<UploadProps> = (props) => {
    const getAcceptFile = (type: string) => {
        switch (type) {
            case 'image':
                return acceptImage
            case 'file':
                return '*'
            default:
                return type
        }
    }
    const {
        // accept = 'image/gif,image/jpeg,image/png',
        onExceed = () => undefined,
        lt = 2,
        acceptType = 'image',
        onResolve = () => undefined,
    } = props
    const [toastOpen, setToastOpen] = useState(false)
    const hanleUploadFile = async (file: File) => {
        try {
            const res: any = await uploadFile(file)
            onResolve(res.url, file.name, file.type)
            if (props.onfinally) {
                props.onfinally()
            }
        } catch (error) {
            if (props.onfinally) {
                props.onfinally()
            }
            console.error(error)
        }
    }
    const uploadProps = {
        accept: getAcceptFile(acceptType),
        beforeUpload(file: File) {
            console.log(file)
            console.log('beforeUpload', file.name)
            const isExceed = file.size / 1024 / 1024 < lt

            if (!isExceed) {
                onExceed()
                setToastOpen(true)
                return false
            }
            hanleUploadFile(file)
            return false
        },
        onStart: (file: File) => {
            console.log('onStart', file.name)
            if (props.onStart) {
                props.onStart(file)
            }
        },
        onSuccess(file: File) {
            console.log('onSuccess', file)
        },
        onProgress(step: any, file: File) {
            console.log('onProgress', Math.round(step.percent), file.name)
        },
        onError(err: Error) {
            console.log('onError', err)
        },
    }
    return (
        <>
            <RcUpload {...uploadProps} className='rc-upload'>
                {props.children}
            </RcUpload>
            <Toast
                message={`文件超出${props.lt}M`}
                color='error'
                position='top'
                isOpen={toastOpen}
                onClose={() => setToastOpen(false)}
            />
        </>
    )
}

export default Upload
